export default __webpack_public_path__ + "static/media/HUD-Effects-02.9b5a267a.jpg";